export default [
    {
        path: '/events',
        name: 'EventsList',
        component: () => import('@/views/Events/EventsList.vue'),
        meta: { permission: 'events.view' }
    },
    {
        path: '/events/new',
        name: 'EventCreate',
        component: () => import('@/views/Events/EventBuilder.vue'),
        meta: { permission: 'events.create' }
    },
    {
        path: '/events/:id',
        name: 'EventView',
        component: () => import('@/views/Events/EventView.vue'),
        meta: { permission: 'events.view' }
    },
    {
        path: '/events/:id/edit',
        name: 'EventEdit',
        component: () => import('@/views/Events/EventBuilder.vue'),
        meta: { permission: 'events.update' }
    }
]
